import React from 'react'

const AuthenticatedPageNotFound = () => (
  <h1>Authenticated Page Not Found</h1>
)

export default AuthenticatedPageNotFound



// WEBPACK FOOTER //
// ./src/routes/authenticated/AuthenticatedPageNotFound.js